<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_select search_inputBox" v-model="params.bill_lading_no" placeholder="提单号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.ship_no" placeholder="船名" size="mini"></el-input>
                <el-input class="search_select search_inputBox" v-model="params.batch_no" placeholder="批次号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="树种" @visible-change="getBreed">
                    <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.heap_no" placeholder="堆号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.length" placeholder="长度" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.diameter" placeholder="直径" size="mini"></el-input>
                <!-- <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入窑时间"></el-date-picker>
                </div> -->
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getDetail()">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <!-- <div class="btnList clearfix"> -->
                <!-- <el-button class="funcPublicBtn funcPublicBtnChecked">批量修改</el-button>
                <el-button class="funcPublicBtn">批量删除</el-button> -->
            <!-- </div> -->
            <div class="tableBox">
                <div class="machBack" @click="machBack">返回流程详情</div>
                <tabletem :isLoading="tableLoading" class="tableCompontent" :tablecol="tableCol" :tabledata="list" @getRow="selectChange" @getTableEdit="edit" @getTableDelete="del"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">合计</div>
                <div class="totalNumber">根数:{{totalObj.numbers}}</div>
                <div class="totalNumber">立方:{{totalObj.cube}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="processing.wood.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <el-dialog v-dialog-drag :visible.sync="editDialog" class="eldialog eldialogA" width="630px" :modal="false" title="修改" custom-class="full_dialog">
            <el-form  :model="editForm" class="clearfix">
                <div class="eldialogFormBox eldialogFormTag clearfix">
                    <el-form-item   label="合同号：">
                        <el-input v-model="editForm.contract_no"></el-input>
                    </el-form-item>
                    <el-form-item   label="船名：">
                        <el-input v-model="editForm.ship_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="树种：">
                        <el-select v-model="editForm.breed_id" clearable  @visible-change="getBreed">
                            <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item   label="长度：">
                        <el-input v-model="editForm.length"></el-input>
                    </el-form-item>
                    <el-form-item   label="直径：">
                        <el-input v-model="editForm.diameter"></el-input>
                    </el-form-item>
                    <el-form-item   label="外币单价：">
                        <el-input v-model="editForm.bill_lading_no"></el-input>
                    </el-form-item>
                    <el-form-item   label="销售单价：">
                        <el-input v-model="editForm.bill_lading_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="预计入库时间：">
                        <el-date-picker v-model="editForm.actual_arrival_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                </div>
                <div class="eldialogFormBox">
                    <el-form-item  label="提单号：">
                        <el-input v-model="editForm.bill_lading_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="批次号：">
                        <el-input v-model="editForm.batch_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="堆号：">
                        <el-input v-model="editForm.contract_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="根号：">
                        <el-input v-model="editForm.bale_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="码单立方：">
                        <el-input v-model="editForm.cube"></el-input>
                    </el-form-item>
                    <el-form-item  label="采购单价：">
                        <el-input v-model="editForm.contract_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="预计到港时间：">
                        <el-date-picker v-model="editForm.expected_shipping_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="备注：">
                        <el-input v-model="editForm.remark"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn">取消</el-button>
                <el-button  class="funcPublicBtn dialogBtn" @click="addContract(1)">确定保存</el-button>
                <!-- <el-button class="dialogBtn funcPublicBtn"  @click="isShowContract=!isShowContract">关闭</el-button> -->
            </div>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .dialog_path_title{text-align: center;font-size:18px; font-weight:bold; line-height:25px; color: #333333;padding-bottom:20px;}
    .tableBox{position: relative;}
    .machBack{position: absolute;top:0;right:0;z-index: 2;}
    .tableCompontent{position: relative;z-index: 1;}
</style>
<script>
    import pagination from '../../../components/pagination.vue'
    import tabletem from '../../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                processing_id:"",
                start_time:"",
                end_time:"",
                module:localStorage.dw_erp_power_code,
                editDialog:false,
                editForm:{

                },
                selectList:[],
                params:{
                    processing_id:"",
                    start_time:"",
                    end_time:"",
                    contract_no:"",
                    bill_lading_no:"",
                    ship_no:"",
                    batch_no:"",
                    breed_id:"",
                    heap_no:"",
                    length:"",
                    diameter:"",
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                breedList:[],
                selectMap:{
                    user:[],
                    customerSource:[],
                    customerAttribute:[]
                },
                selectDialogVisible:false,
                // dialog START
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[	
                    {colName:"合同号",colKey:"contract_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"根号",colKey:"bale_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度(m)",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"直径(mm)",colKey:"diameter",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"码单立方",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                // dialog END
                show_upload : false,
                totalObj:{}
            }
        },
        created(){
            this.processing_id = sessionStorage.getItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WOODDETAIL")
            sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WOODDETAIL")
            this.getDetail()
            this.getBreed()
        },
        methods:{
            machBack(){
                this.$root.$children[0].$children[0].addTab({
                    name: '加工单流程详情'+this.processing_id,
                    label: '加工单流程详情',
                    content: 'machiningFakeDetail'
                });
            },
            getBreed(){
                this.postFunc("/erp/processing.wood.breed",{processing_id:this.processing_id},res=>{
                    this.breedList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            filterConfirm(){
                this.getDetail()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time = "";
                this.end_time = "";
                this.params.processing_id = this.processing_id;
                this.getDetail()
            },
            selectChange(row){
                this.selectList=row;
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFuncLoading("/erp/customer.delete",{id:id},()=>{
                        this.tip("删除成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            edit(id){
                this.dialogVisible=true;
                this.updataType=3;
                this.list.forEach(item=>{
                    if(item.id==id){
                        let editList=JSON.parse(JSON.stringify(item));
                        if(item.province_id!=0){
                            this.getArea(item.province_id).then(res=>{
                                this.cityList=res.data.data;
                            })
                        }
                        this.form_params=editList;
                        this.form_params = this.clearZero(this.form_params)
                    }
                })
            },
            getDetail(){
                this.params.start_time = this.formatTimeZero(this.start_time)
                this.params.end_time = this.formatTimeZero(this.end_time)
                this.params.processing_id = this.processing_id;
                this.tableLoading = true;
                this.postFunc("/erp/processing.wood.list",this.params,res=>{
                    this.pl(res)
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.totalObj = res.data.data.total;
                    this.list=res.data.data.data.data;
                    this.list.forEach((item)=>{
                        item.length = this.keepLimit(item.length)
                        item.diameter = this.keepLimit(item.diameter)
                        item.cube = this.keepLimit(item.cube)
                    })
                    this.filter = res.data.data.columns;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            }
        },
         watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
        }
    }
</script>
